/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * RateStarIcon - Auto-generated from icon.js
 */
export const RateStarIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M14.7344 5.87143L10.4175 5.21446L8.4878 1.1177C8.43509 1.00554 8.34838 0.914735 8.24127 0.859542C7.97263 0.720669 7.64619 0.836396 7.51188 1.1177L5.58214 5.21446L1.2653 5.87143C1.14628 5.88924 1.03747 5.94799 0.954157 6.03701C0.85344 6.14541 0.79794 6.29125 0.799853 6.44249C0.801765 6.59372 0.860935 6.73797 0.964359 6.84354L4.08765 10.0323L3.34976 14.535C3.33245 14.6397 3.34352 14.7474 3.38171 14.8459C3.41989 14.9444 3.48367 15.0297 3.5658 15.0922C3.64793 15.1547 3.74514 15.1918 3.84639 15.1993C3.94764 15.2069 4.04889 15.1846 4.13866 15.135L7.99984 13.0091L11.861 15.135C11.9664 15.1937 12.0888 15.2133 12.2062 15.1919C12.502 15.1385 12.7009 14.8448 12.6499 14.535L11.912 10.0323L15.0353 6.84354C15.1203 6.7563 15.1764 6.64235 15.1934 6.51772C15.2393 6.20615 15.0319 5.91772 14.7344 5.87143Z" fill="#FAB400" />
	</svg>
);

export default RateStarIcon;
